import { Checkbox, DataSourceMode, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCollectionsProfile } from "./autogen/AutogenLayoutCollectionsProfile";

export class CollectionsProfile extends AutogenLayoutCollectionsProfile {
    override onLoad() {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;
    }

    sourceCollectionsProfileOnDisplay() {
        this.checkboxCollectionsUserExclude.enabledDuringAdd = !!this.mainDataSource.activeRow?.getString("collections_user_ids", null);
        this.checkboxCollectionsUserExclude.enabledDuringUpdate = !!this.mainDataSource.activeRow?.getString("collections_user_ids", null);
        this.checkboxCustomerExclude.enabledDuringAdd = !!this.mainDataSource.activeRow?.getString("customer_ids", null);
        this.checkboxCustomerExclude.enabledDuringUpdate = !!this.mainDataSource.activeRow?.getString("customer_ids", null);
        this.checkboxNextActionExclude.enabledDuringAdd = !!this.mainDataSource.activeRow?.getString("next_action_codes", null);
        this.checkboxNextActionExclude.enabledDuringUpdate = !!this.mainDataSource.activeRow?.getString("next_action_codes", null);
    }

    textboxCustomerIdsBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.collections_ok = 'Y';
    }

    textboxCustomerIdsOnLookupModelSelection() {
        this.updateCheckboxStates(this.checkboxCustomerExclude, "customer_ids");
    }

    textboxCollectionsUserIdsOnLookupModelSelection() {
        this.updateCheckboxStates(this.checkboxCollectionsUserExclude, "collections_user_ids");
    }

    textboxNextActionCodesOnLookupModelSelection() {
        this.updateCheckboxStates(this.checkboxNextActionExclude, "next_action_codes");
    }

    updateCheckboxStates(checkbox: Checkbox, field: string) {
        const isFieldSet: boolean = !!this.mainDataSource.activeRow?.getString(field, null);
        checkbox.enabledDuringAdd = isFieldSet;
        checkbox.enabledDuringUpdate = isFieldSet;
        if (!isFieldSet && this.mainDataSource.mode !== DataSourceMode.SEARCH) {
            checkbox.checked = false;
        }
    }
}
